import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { Subscription } from 'rxjs';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';

@Component({
    selector: 'setup-capture-email',
    templateUrl: 'setup-capture-email.page.html',
    styleUrls: ['setup-capture-email.page.scss']
})
export class SetupCaptureEmailPage implements OnInit, OnDestroy {

    public showLinkAccount: boolean = false;
    public showDoNotAsk: boolean = false;
    public setupPage: boolean = true;
    readonly type: string;
    public isDesktopMode;

    constructor(
      private store: Store<AppState>,
      private walletService: WalletService,
      private nav: NavController,
      private appMode: AppModeService,
      private route: ActivatedRoute
    ) {
      this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
      this.type = this.route.snapshot.params['type'] ? this.route.snapshot.params['type'] : 'new';
    }

    async ngOnInit() {
      await this.walletService.incrementLoginAttempts();
      this.route.queryParams.subscribe(async(params) => {
        if(params['skip'])
        {
          const info = await this.walletService.getStorageEmail();
          info.never = false;
          this.walletService.setStorageEmail(info);
          setTimeout(async () => {
            await this.walletService.completeSetup();
            await this.nav.navigateRoot('/wallet/assets');
          }, 100);
        }
      });
    }


    ngOnDestroy() {}

}
